import React from 'react';
import { Box } from '@mui/material';
import ChildCareOutlinedIcon from '@mui/icons-material/ChildCareOutlined';
import { currentAccount } from '../../../helpers/accounts';

// Says which reading programme the reader is signed into. A library account
// shows nothing: that is the ordinary case and needs no label.
const AccountBadge = () => {
    const account = currentAccount();

    if (!account || !account.programName) return null;

    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                px: 1,
                py: 0.25,
                mr: 1,
                borderRadius: 4,
                fontSize: 13,
                whiteSpace: 'nowrap',
                color: 'rgba(255,255,255,0.95)',
                background: 'rgba(0,0,0,0.18)'
            }}
        >
            <ChildCareOutlinedIcon sx={{ fontSize: 16 }} />
            {account.programName}
        </Box>
    );
};

export default AccountBadge;
